// UsageMetrics component for AgenticRCM
import React from 'react';

const formatDate = (dateString) => {
  if (!dateString) return '';
  try {
    return new Date(dateString).toLocaleDateString();
  } catch (e) {
    return dateString;
  }
};

const UsageMetrics = ({ usageMetrics, planLimits }) => {
  if (!usageMetrics || usageMetrics.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-600">No usage data available for the current billing period.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {usageMetrics.map((metric, index) => (
        <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-sm font-medium text-gray-700">
              {metric.metric_name?.replace('_', ' ').toUpperCase() || 'METRIC'}
            </h3>
            <div className="text-2xl font-bold text-blue-600">
              {metric.metric_value?.toLocaleString() || 0}
            </div>
          </div>
          <p className="text-xs text-gray-600 mb-4">
            {formatDate(metric.period_start)} - {formatDate(metric.period_end)}
          </p>
          
          {planLimits && planLimits[metric.metric_name] && planLimits[metric.metric_name] !== -1 && (
            <div className="space-y-2">
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                  style={{
                    width: `${Math.min(100, (metric.metric_value / planLimits[metric.metric_name]) * 100)}%`
                  }}
                />
              </div>
              <p className="text-xs text-gray-600">
                {metric.metric_value} / {planLimits[metric.metric_name].toLocaleString()} 
                ({Math.round((metric.metric_value / planLimits[metric.metric_name]) * 100)}%)
              </p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default UsageMetrics;

